import React from "react";

export default function ErrorCheckbox({ onChange, value, loading }) {
   return (
      <div title={value === "error"?"Fehler, bitte nochmal versuchen...":null}>
         <button
            className={loading ? "simple-loading" : ""}
            style={{
               border: "solid 1px #ccc",
               borderRadius: "8px",
               width: "32px",
               height: "32px",
               ...(value === "error"
                  ? { background: "#c00", outlineOffset:"2px", outline: "dashed 2px  #f00", borderRadius: 0 }
                  : value
                    ? { background: "#090", borderRadius: "20px" }
                    : { backgroundColor: "#333" }),
            }}
            onClick={() => {
               onChange();
            }}
         ></button>
      </div>
   );
}
